export default "__VITE_ASSET__86e1a72a__"